import React from 'react';

const UnderMaintenance = () => {
    
  return (
    <div className="d-flex vh-100 justify-content-center align-items-center bg-light">
      <div className="text-center p-4 border rounded shadow bg-white">
        <img
          src="https://cdn-icons-png.flaticon.com/512/564/564445.png"
          alt="Under Maintenance"
          width="100"
          className="mb-3"
        />
        <h1 className="h3 mb-2 text-warning" onClick={()=>{console.log('REACT_APP_API_BASE_URL : ', process.env.REACT_APP_LOGIN_URL)}}>We'll be back soon!</h1>
        <p className="text-muted mb-0">
          Our website is temporarily under maintenance. <br />
          Thank you for your patience.
        </p>
      </div>
    </div>
  );
};

export default UnderMaintenance;
